import { LoaderCircle } from "lucide-react";
import { forwardRef, type ButtonHTMLAttributes } from "react";

type ButtonVariant = "primary" | "secondary" | "quiet" | "danger";

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  loading?: boolean;
  loadingLabel?: string;
  variant?: ButtonVariant;
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(function Button(
  {
    children,
    className = "",
    disabled,
    loading = false,
    loadingLabel,
    variant = "primary",
    type = "button",
    ...props
  },
  ref,
) {
  const classes = ["button", `button--${variant}`, className].filter(Boolean).join(" ");
  return (
    <button
      ref={ref}
      aria-busy={loading || undefined}
      className={classes}
      disabled={loading ? true : disabled}
      type={type}
      {...props}
    >
      {loading ? <LoaderCircle aria-hidden="true" className="button__spinner" size={18} /> : null}
      {loading && loadingLabel ? loadingLabel : children}
    </button>
  );
});
